package pwgs.ui.components

import visage.core.Components
import visage.dom.div
import kotlin.math.absoluteValue

fun Components.BarChart(height: Int, barColor: String, maxValue: Int, items: List<BarChartItem>) = this.registerFunctionalComponent({}) {
    var max = maxValue
    var min = 0
    items.forEach {
        if (it.value > max) {
            max = it.value
        }
        if (it.value < min) {
            min = it.value
        }
    }
    val diff = max - min
    div {
        style.apply {
            width = "100%"
            this.height = "${height}px"
            display = "flex"
            flexDirection = "row"
            alignItems = "flex-end"
            padding = "8px"
        }

        items.forEach {
            var h = ((it.value.toFloat() / diff) * (height - 16)).toInt()
            if (h < 1) {
                h = 1
            }

            div {
                style.apply {
                    display = "inline-flex"
                    margin = "1px"
                    flexGrow = "1"
                    this.height = "${h}px"
                    backgroundColor = barColor
                }
                attr["title"] = "${it.title}"
            }
        }
    }
}

fun Int.convertToDecimalString(decimalPoints: Int): String {
    if (this == 0) {
        return "0"
    }
    val isMinus = this < 0;
    val inStr = this.absoluteValue.toString()

    val res = if (inStr.length < decimalPoints) {
        var t = "0."
        val zeroCount = decimalPoints - inStr.length
        t += "0".repeat(zeroCount)
        t += inStr
        t
    } else if (inStr.length == decimalPoints) {
        "0.$inStr"
    } else {
        var t = ""
        var intCount = inStr.length - decimalPoints
        inStr.forEachIndexed { index, c ->
            t += c
            if (index == intCount - 1) {
                t += "."
            }
        }
        t
    }

    if (isMinus) {
        return "-$res"
    } else {
        return res
    }
}

class BarChartItem(
    val title: String,
    val value: Int,
)